module.exports = __webpack_public_path__ + "static/media/maine.cd11ab18.svg";